const appsyncConfig = {
  graphqlEndpoint: 'https://ykoryxf7kjfvbicrza4kmz7dny.appsync-api.ap-southeast-2.amazonaws.com/graphql',
  region: 'ap-southeast-2',
  authenticationType: 'OPENID_CONNECT'
}

export default appsyncConfig
